import React, {useEffect, useState} from 'react';
import {CartProvider} from "../Utils/UseCartContext";
import PreProcessWrapper from "../PreProcessWrapper";
import {ReactQueryDevtools} from "react-query-devtools";
import {SnippetProvider} from "../Utils/UseSnippetContext";
import useServiceUrls from "../Utils/UseServiceUrls";
import {getParameterCaseInsensitive, normalizeObjectKeys} from "../Helpers/Functions";
import useMyRewardsConfig from "../Utils/UseMyRewardsConfig";
import LoadingSpinner from "../LoadingSpinner";

type HostedSnippetProps = {

}

export default function HostedSnippet(props: HostedSnippetProps) {
    const [domain, setDomain] = useState("")
    const [code, setCode] = useState("")
    const [deviceCode, setDeviceCode] = useState("MyRewards");
    const [snippetArgs, setSnippetArgs] = useState<any>({})

    useEffect(() => {
        const queryString = require('query-string');
        const parsed = queryString.parse(window.location.search);
        const args = getParameterCaseInsensitive(parsed, 'bl_snippetargs')
        const jsonArgs = JSON.parse(args ?? '{}')
        const lowercaseArgs = normalizeObjectKeys(jsonArgs)
        console.log(lowercaseArgs)
        setCode(getParameterCaseInsensitive(parsed, 'bl_snippetcode'))
        setDomain(getParameterCaseInsensitive(parsed, 'bl_logindomain'))
        setSnippetArgs({...snippetArgs, ...lowercaseArgs, DeviceCode: deviceCode})
    }, [])

    if (code === "" || code === undefined || domain === "" || domain === undefined || deviceCode === "" || deviceCode === undefined)
        return <></>
    else
        return (
            <SnippetProvider domain={domain} deviceCode={deviceCode ?? 'MyRewards'}
                             clubCode={snippetArgs.clubcode ?? ''} useLogout={snippetArgs.uselogout}
                             returnUrlParam={snippetArgs.returnurlparameter ?? 'ReturnUrl'} useRelativeReturnUrl={snippetArgs.userelativereturnurl ?? false} loginUrl={snippetArgs.loginurl ?? ''}
                             cartUid={snippetArgs.cartuid} cartExternalId={snippetArgs.cartexternalid}
                             cartSourceExternalId={snippetArgs.cartsourceexternalid} cartAmount={snippetArgs.cartamount}
                             onCompleteFunction={snippetArgs.onsnippetcomplete ?? 'blOnSnippetComplete'}
                             lineUid={snippetArgs.lineuid} alertUid={snippetArgs.alertuid} redirectToHome={snippetArgs.paymentredirecttohome}
                             productCode={snippetArgs.productcode}>
                <CartProvider >
                    <PreProcessWrapper snippetCode={code}/>
                    <ReactQueryDevtools initialIsOpen={false}/>
                </CartProvider>
            </SnippetProvider>
        )
}